/* eslint-disable camelcase */
import { API } from "./API";

export const getK3Docs = (query) => {
  var {
    id,
    docMid,
    docIds,
    keyword,
    sortBy,
    type,
    limit = 20,
    page = 1,
    label,
    hide_types,
    sort_field,
    sort_order
  } = query;

  var queryStr = sortBy ? `sort=${sortBy}` : `sort=createdAt`;

  if (id)
    queryStr += `&id=${id}`;

  if (docMid)
    queryStr += `&doc_mid=${docMid}`;

  if (docIds)
    queryStr += `&doc_ids=${docIds.join(',')}`;

  if (keyword)
    queryStr += `&keyword=${keyword}`;

  if (type)
    queryStr += `&type=${type}`;

  if (limit)
    queryStr += `&limit=${limit}`;

  if (page)
    queryStr += `&page=${page}`;

  if (label)
    queryStr += `&tags=${label}`;

  if (hide_types && Array.isArray(hide_types) && hide_types.length > 0)
    queryStr += `&hide_types=${hide_types.join(',')}`;

  if (sort_field)
    queryStr += `&sort_field=${sort_field}`;

  if (sort_order)
    queryStr += `&sort_order=${sort_order}`;

  return API.get(`${process.env.REACT_APP_API_URL}/api/k3doc?${queryStr}`);
}

export const setK3Docs = (docs, query = {}) => {
  var { generate_version = false, delete_all_versions = false } = query;

  var queryStr = `generate_version=${generate_version}&delete_all_versions=${delete_all_versions}`;

  return API.post(`${process.env.REACT_APP_API_URL}/api/k3doc?${queryStr}`, docs);
}

export const getK3DocVersions = (doc_mid) => {
  return API.get(`${process.env.REACT_APP_API_URL}/api/k3doc/doc-mid-versions?doc_mid=${doc_mid}`);
}

export const k3docService = {
  getK3Docs,
  setK3Docs,
  getK3DocVersions
} 